import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-shopping-bag',
  standalone: true,
  templateUrl: '../../assets/shopping-bag.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamShoppingBagIcon {}
